import React from 'react';

import { Box, Collapse } from '@mui/material';

import { observer } from 'mobx-react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';

import { useStore } from 'utils/hooks/store';

import { EntityModules } from 'core/constants';
import { CenteredCircularProgress } from 'components/Progress';

import DataError from 'containers/Error/DataError';

import { Section, SectionContainerHeader, TitleWrapper, Title, Description } from './styles';

import RelevantFieldsSection from './RelevantFieldsSection';

const RelevantFields = (): React.ReactElement => {
  const { entityLayout, entityFields } = useStore();

  const [expanded, setExpanded] = React.useState(true);

  const handleExpandClick = (): void => {
    setExpanded((prevState) => !prevState);
  };

  React.useEffect(() => {
    const loadLayout = async (): Promise<void> => {
      // always load layout to have the latest data
      await entityLayout.loadLayout(EntityModules.Events);

      // always load fields to have the latest data
      await entityFields.loadFields(EntityModules.Events);
    };
    loadLayout();
  }, [entityLayout, entityFields]);

  if (!entityLayout.isLoaded || !entityFields.isLoaded) {
    return <CenteredCircularProgress />;
  }

  if (entityLayout.error || entityFields.error) {
    return <DataError />;
  }

  return (
    <Section>
      <SectionContainerHeader $expanded={expanded}>
        <TitleWrapper onClick={handleExpandClick}>
          {expanded ? (
            <ExpandLess aria-label="show less" fillOpacity="0.54" />
          ) : (
            <ExpandMore aria-label="show more" fillOpacity="0.54" />
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Title id="section-title">Relevant & Required Fields</Title>
            <Description>
              Choose the fields shown by default at this stage and mark which ones must be completed before moving
              forward.
            </Description>
          </Box>
        </TitleWrapper>
      </SectionContainerHeader>
      <Collapse in={expanded} sx={{ padding: expanded ? '0 16px 16px' : '0' }}>
        <Box sx={{ margin: '16px' }}>
          {entityLayout.data?.order.map((container) => {
            const containerData = entityLayout.data?.properties[container];
            if (!containerData) return null;

            const { title, order: containerOrder } = containerData;

            return <RelevantFieldsSection key={container} title={title} fields={containerOrder} />;
          })}
        </Box>
      </Collapse>
    </Section>
  );
};

export default observer(RelevantFields);
